import { Navigate } from "react-router";
import { useAuthStore } from "~/stores/auth.store";
import { EApprovalStatus, EUserType } from "~/types/enums";

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading, user, business } = useAuthStore();

  if (isLoading) {
    return (
      <div className="flex h-dvh items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (user.type !== EUserType.Business || !business) {
    return <Navigate to="/login" replace />;
  }

  if (business.approvalStatus === EApprovalStatus.Pending) {
    return <Navigate to="/pending-approval" replace />;
  }

  if (business.approvalStatus === EApprovalStatus.Blocked) {
    return <Navigate to="/blocked" replace />;
  }

  return <>{children}</>;
}

export function GuestGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading, business } = useAuthStore();

  if (isLoading) {
    return (
      <div className="flex h-dvh items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (isAuthenticated && business) {
    if (business.approvalStatus === EApprovalStatus.Pending) {
      return <Navigate to="/pending-approval" replace />;
    }
    if (business.approvalStatus === EApprovalStatus.Blocked) {
      return <Navigate to="/blocked" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
